// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"styles_sectionTitle__z1_bK","chartControls":"styles_chartControls__6eNya"};